import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { GroupExistingCustomerFormValues } from './types';

export const useAddCompanionshipsMutation = ({
    groupId,
    reservationId,
}: {
    groupId: string;
    reservationId: string;
}) => {
    return useRepositoryMutation('companionships', 'add', {
        transformParams: ({ companionId }: GroupExistingCustomerFormValues) => {
            return {
                groupId,
                reservationId,
                companionId,
            };
        },
        onSuccess: () => {
            showSuccessAlert({ description: lt('AddCompanionSuccessMessage') });
        },
    });
};
